

export const Home = () => {
  const ImportantDates = () => {
    return (
      <>
        <div className="max-w-fit mx-auto text-white bg-[#08ACF2] hover:bg-[hsl(198,94%,39%)] p-2 border border-blue-700 rounded-md text-sm md:text-xl mt-[40px]">
          <a
            href="https://nhwm.in/signup"
            target="_blank"
            rel="noopener noreferrer"
          >
            &#10153; Click here to apply for BRT 2025-2026
          </a>
        </div>

        <p className="justify-self-start text-md md:text-xl lg:text-2xl text-gray-600 font-extrabold mt-[50px]">
          Click any heading below to learn more :-
        </p>
        <div
          tabIndex={0}
          id="info"
          className="collapse collapse-plus border border-base-300 bg-base-200 mt-4"
        >
          <input type="checkbox" />
          <div className="collapse-title text-xl font-bold bg-slate-300">
            IMPORTANT INFORMATION REGARDING BRT, 2025-2026
          </div>
          <div className="collapse-content flex flex-col gap-3 md:text-lg">
            {/* You can modify or copy the same structure from BRT 2024 and update dates/content */}
            <div className="text-center text-red-500 font-semibold italic"></div>
            {/* Example placeholders */}
            <div className="p-3 bg-slate-200 flex-col flex rounded-md gap-y-3 mb-3 mt-6">
              <span className="text-black font-bold">
                Login Credentials – '24 to 48 hours after Application
                Submission'
              </span>
            </div>
            <div className="p-3 bg-slate-200 flex-col flex rounded-md gap-y-3 mb-3 mt-6">
              <span className="text-black font-bold">
                The Slots for the BRT 2025-26 Exam have been Released.
              </span>
            </div>
            <div className="pl-6">
              <p>
                From{" "}
                <span className="font-semibold text-lg">
                  10th December 2025
                </span>{" "}
                onward for <span className="font-semibold">RWO</span>
              </p>
              <p>
                From{" "}
                <span className="font-semibold text-lg">
                  15th December 2025
                </span>{" "}
                onward for <span className="font-semibold">DWO</span>
              </p>
            </div>
            <div className="flex justify-center">
              <a
                href="https://exam.nhwm.in/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-lg underline font-semibold text-indigo-600"
              >
                Click Here to Go to Exam Dashboard
              </a>
            </div>
          </div>
        </div>
      </>
    );
  };

  const BRTResult = () => {
    return (
      <div
        tabIndex={0}
        className="collapse collapse-plus border border-base-300 bg-base-200 mt-4"
        id="result"
      >
        <input type="checkbox" />
        <div className="collapse-title text-xl font-bold bg-slate-300">
          BRT RESULT, 2025-2026 HAS BEEN RELEASED
        </div>
        {/* add collapase content to hide the content */}
        <div className=" flex flex-col gap-3 md:text-lg py-6"> 
          <div className="">
            {/* <div className="mx-auto">
              <img
                src={rwoItwoHrwoResult}
                alt="qualified candidates"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={dwoResult1}
                alt="qualified candidates"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={dwoResult2}
                alt="qualified candidates"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={awoResult}
                alt="qualified candidates"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
            </div>
            <div className="mt-4 border-t-2 border-gray-400">
              <h3 className="text-2xl font-bold text-center mt-3">
                Waiting List of Candidates
              </h3>
              <div>
                <img
                  src={waitingList1}
                  alt="waiting list candidates"
                  className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
                />
                <img
                  src={waitingList2}
                  alt="waiting list candidates"
                  className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
                />
                <img
                  src={waitingList3}
                  alt="waiting list candidates"
                  className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
                />
                <img
                  src={waitingList4}
                  alt="waiting list candidates"
                  className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
                />
              </div>
            </div>
          </div> */}
            <div className="text-center text-red-500 font-semibold italic">
              <a href="https://exam.nhwm.in/" className="text-blue-500 hover:underline" rel="noopener noreferrer" target="_blank">
                Click Here to Go to Exam Dashboard to View Your Result.
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const VivaDate = () => {
    return (
      <div
        tabIndex={0}
        className="collapse collapse-plus border border-base-300 bg-base-200 mt-4"
      >
        <input type="checkbox" />
        <div className="collapse-title text-xl font-bold bg-slate-300">
          VIVA FOR THE SELECTED CANDIDATES IS GOING ON (BRT 2025-2026)
        </div>
        <div className=" flex flex-col gap-3 md:text-lg py-6">
          <div>
            <div className="text-center text-red-500 font-semibold italic">
              <h1>RWO and DWO Interview and Personal Interactions have been completed.</h1>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const VivaResult = () => {
    return (
      <div
        tabIndex={0}
        className="collapse collapse-plus border border-base-300 bg-base-200 mt-4"
        id="viva"
      >
        <input type="checkbox" />
        <div className="collapse-title text-xl font-bold bg-slate-300">
          VIVA RESULT (BRT 2025-2026)
        </div>
        <div className="flex flex-col gap-3 md:text-lg py-6">
          <div>
            <div className="text-center text-red-500 font-semibold italic">
              <h1>RWO and DWO Viva Results have been Released.</h1>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const StartOfTraining = () => {
    return (
      <div
        tabIndex={0}
        className="collapse collapse-plus border border-base-300 bg-base-200 mt-4"
        id="schedule"
      >
        <input type="checkbox" />
        <div className="collapse-title text-xl font-bold bg-slate-300">
          TRAINING SCHEDULE FOR THE SELECTED CANDIDATES (BRT 2025-2026)
        </div>
        <div className="flex flex-col gap-3 md:text-lg py-6">
          <div>
            <div className="text-center text-red-500 font-semibold italic">
              <h1>Registration is going on for Certification Training Programme (CTP).</h1>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <div className="flex justify-center items-center flex-col gap-4 pl-5 pr-5 pb-5 navbar-offset">
        <div className="container"></div>
        <div className="container">
          <ImportantDates />
          <BRTResult />
          <VivaDate />
          <VivaResult />
          <StartOfTraining />
        </div>

        <div className="max-w-fit mx-auto text-white bg-[#08ACF2] hover:bg-[hsl(198,94%,39%)] p-2 border border-blue-700 rounded-md text-sm md:text-xl">
          <a
            href="https://nhwm.in/signup"
            target="_blank"
            rel="noopener noreferrer"
          >
            &#10153; Apply for BRT 2025-2026
          </a>
        </div>

        <div className="flex  justify-center my-2">
          <div className="max-w-md  mx-auto text-white bg-[#08ACF2] hover:bg-[hsl(198,94%,39%)] p-2 border border-blue-700 rounded-md text-sm md:text-xl">
            <a
              href="https://www.facebook.com/NHWMOH"
              target="_blank"
              rel="noopener noreferrer"
            >
              &#10153; Follow our Facebook Page
            </a>
          </div>
        </div>
        <div className="flex flex-col gap-5 justify-center xl:flex-row xl:justify-between-between xl:w-full py-5">
          <a
            href="/intimation-letters-2025"
            className="bg-[#08ACF2] p-2 rounded-md hover:bg-[hsl(198,94%,39%)] text-white text-sm md:text-xl"
          >
            &#10153; Intimation Letters for BRT 2025-26
          </a>
        </div>
      </div>
    </div>
  );
};
